module.exports = __webpack_public_path__ + "assets/img/Lunds_university_white.c5e69121.svg";